var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnPreSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6298 0.469727H13.6198C6.10319 0.469727 0.00976562 6.56312 0.00976562 14.0797V14.0897C0.00976562 21.6063 6.10319 27.6997 13.6198 27.6997H13.6298C21.1464 27.6997 27.2398 21.6063 27.2398 14.0897V14.0797C27.2398 6.56312 21.1464 0.469727 13.6298 0.469727Z",
    fill: "#0DD400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7898 6.6592L21.7498 6.62923C21.0498 6.03923 19.9998 6.12919 19.4098 6.83919L10.5598 17.3392C10.3898 17.5492 10.0798 17.5692 9.86976 17.3992L7.27976 15.2092C6.57976 14.6192 5.52976 14.7092 4.93976 15.4192C4.34976 16.1192 4.43976 17.1692 5.14976 17.7592L9.76975 21.6492C9.90975 21.7692 10.0698 21.8392 10.2398 21.8792C10.6798 22.0192 11.1798 21.8792 11.4898 21.5092L22.0198 9.01918C22.6098 8.31918 22.5198 7.26922 21.8098 6.67922L21.7898 6.6592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPreSuccess);
export default __webpack_public_path__ + "static/media/btn_pre_success.070834be5c50fd261bc887f4552d0c23.svg";
export { ForwardRef as ReactComponent };